export const banners_area = "page-info"
export const banners_entity = "banners"

export const popups_area = "page-info"
export const popups_entity = "popups"

export const landingpages_area = "page-info"
export const landingpages_entity = "landing-pages"

export const anuncios_area = "page-info"
export const anuncios_entity = "anuncios"

// C00001	Mercado Libre
// C00002	Zoho Landing Page
// C00003	Zoho Checkout
// export const canales = [
//   { value: "", label: "Seleccionar Canal" },
//   { value: "C00001", label: "Mercado Libre" },
//   { value: "C00002", label: "Zoho Landing Page" },
//   { value: "C00003", label: "Zoho Checkout" },
// ]

// C00001	Mercado Libre
// C00002	Zoho Landing Page
// C00003	Zoho Checkout
export const canales = [
  { id: "C00001", nombre: "Mercado Libre" },
  { id: "C00002", nombre: "Zoho Landing Page" },
  { id: "C00003", nombre: "Zoho Checkout" },
]
